import {defineStore} from 'pinia';
import redirect_error_page from "@/util/redirect_error_page"
import {IAccountStatus, ILicensedSubject, IHelp} from "@/consts/interfaces";
import { useVersionStore } from './version_store';
import apiRequest from '@/util/api-request';
import { AxiosRequestConfig } from 'axios';


interface IGlobalNavigation {
    account_status: IAccountStatus;
    licensed_subject: Array<ILicensedSubject>;
    licensed_subject_for_nav: Array<ILicensedSubject>;
    selected_menu: string;
    selected_color: string;
    prev_selected_menu: string;
    help_list: Array<IHelp>;
}
export const useGlobalNavigationStore = defineStore('globalNavigationStore', {
    // state
    state: ():IGlobalNavigation => {
        return {
            account_status: {
                number_of_badges: 0,
                number_of_homeworks: 0,
                number_of_mission_cleared_today: 0,
                number_of_stars: 0,
                number_of_study_days: 0,
            },
            licensed_subject: [],
            licensed_subject_for_nav: [],
            selected_menu: "",
            selected_color: "",
            prev_selected_menu: "",
            help_list: []
        }
    },
    // getters
    getters: {
        accountStatus: (state) => {
            return state.account_status
        },
        licensedSubject: (state) => {
            return state.licensed_subject
        },
        licensedSubjectForNav: (state) => {
            return state.licensed_subject_for_nav  
        },
        selectedMenu: (state) => {
            return state.selected_menu
        },
        selectedColor: (state) => {
            return state.selected_color
        },
        prevSelectedMenu: (state) => {
            return state.prev_selected_menu
        },
        helpList: (state) => {
            return state.help_list
        },
    },
    // actions
    actions: {
        async fetchNavAccountStatus(payload:{isMission?: boolean}|null) {
            const versionStore = useVersionStore()
            try {
                const config: AxiosRequestConfig = {
                    method: 'get',
                    url: '/student/api/account/status',
                };
                const account_status = await apiRequest(config);
                if(payload && payload.isMission == true){
                    this.account_status.number_of_badges = account_status.data.number_of_badges
                    this.account_status.number_of_stars = account_status.data.number_of_stars
                    this.account_status.number_of_study_days = account_status.data.number_of_study_days
                }else{
                    this.account_status = account_status.data
                }
                versionStore.saveAppVersion( account_status.headers["x-app-version"])
            }
            catch (e) {
                redirect_error_page(e)
            }
        },
        async fetchNavSubjects() {
            const versionStore = useVersionStore()
            try {
                const config: AxiosRequestConfig = {
                    method: 'get',
                    url: '/student/api/subject/list_available',
                };
                const subjects = await apiRequest(config);
                this.licensed_subject = subjects.data.subjects
                this.licensed_subject_for_nav = subjects.data.subjects_for_nav
                versionStore.saveAppVersion(subjects.headers["x-app-version"])
            }
            catch (e) {
                redirect_error_page(e)
            }
        },
        async fetchHelp() {
            const versionStore = useVersionStore()
            try {
                const config: AxiosRequestConfig = {
                    method: 'get',
                    url: '/student/api/help/list_help',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                };
                const result = await apiRequest(config);
                this.help_list = result.data.helps
                versionStore.saveAppVersion(result.headers["x-app-version"])
            }
            catch (e) {
                redirect_error_page(e)
            }
        },
        saveSelectedMenu(value: string) {
            this.selected_menu = value
            this.selected_color = value
        },
        saveSelectedColor(value: string) {
            this.selected_color = value
        },
        savePrevSelectedMenu(value: string) {
            this.prev_selected_menu = value
        },
    }
})